<template>
  <div class="container-fluid">
    <input id="news-post-images" v-if="galleryOptions !== null" v-file-uploader="galleryOptions" type="file" name="files" class="gallery_media" />
  </div>
</template>

<style lang="scss" scoped>
</style>

<script src="../../../../assets/libs/fileuploader-2.2/jquery.fileuploader.min.js" type="text/javascript"></script>

<script>

import VueFileUploader from "./../../../../directives/VueFileUploader.js";

export default {
  name: "NewsPostImages",
  components: {},
  directives: {
    VueFileUploader
  },
  props: ['newsPost'],
  data() {
    return {
      galleryOptions: null
    };
  },
  mounted() {
    var files = [];

    if (this.newsPost.mediaItems !== null) {
      files = this.newsPost.mediaItems.map(mediaItem => (
      {
          name: 'newsPost.jpg',
          size: 1,
          type: 'image/jpg',
          file: mediaItem.url,
          data: {
            url: mediaItem.url
          }
        }
      ));
    }

    const url = process.env.VUE_APP_API +'/NewsImages/' + this.newsPost.id;

    this.galleryOptions = {
      name: 'news-post-images',
      extensions: ['image/*', 'video/*'],
      deletingImage: false,
      uploadUrl: url,
      deleteUrl: url,
      sortUrl: url,
      files: files
    };
  },
  beforeDestroy: function() {
  },
  methods: {}
};
</script>